/* @flow */

import React from 'react';
import { get } from 'lodash/fp';
import glamorous from 'glamorous';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import liveChallengesBoardSelector from 'app/selectors/liveChallengesBoardSelector';
import LiveChallengesBoard from 'app/components/challenges/LiveChallengesBoard';
import AdImageLink from 'app/components/commons/AdImageLink';
import Sidebar from 'app/components/styled/Sidebar';

type Props = {
  hasLiveChallenge: boolean,
  offsetTop: number,
  rightSideBarAd?: Object
};

const defaultProps = {
  rightSideBarAd: undefined
};

const AdWrapper = glamorous.div(({ hasMarginTop, theme }) =>
  hasMarginTop ? { marginTop: theme.spacing.small } : {}
);

function SidebarRight({ hasLiveChallenge, offsetTop, rightSideBarAd }: Props) {
  return (
    <Sidebar
      location="right"
      top={offsetTop}
      nobackground={rightSideBarAd && rightSideBarAd.enabled && !hasLiveChallenge}
    >
      <Inner>
        {hasLiveChallenge && <LiveChallengesBoard />}
        {rightSideBarAd && rightSideBarAd.enabled && (
          <AdWrapper hasMarginTop={hasLiveChallenge}>
            <AdImageLink ad={rightSideBarAd} />
          </AdWrapper>
        )}
      </Inner>
    </Sidebar>
  );
}

SidebarRight.defaultProps = defaultProps;

function mapStateToProps(state) {
  let hasLiveChallenge = false;

  if (state.user.isSignedIn) {
    const { challenges } = liveChallengesBoardSelector(state);
    hasLiveChallenge = Array.isArray(challenges) && challenges.length > 0;
  }

  return {
    hasLiveChallenge,
    rightSideBarAd: get('settings.kayoAds.rightSideBarAd', state)
  };
}

// IMPORTANT: the pure=false option ensures the nav updates on route change
// $FlowFixMe
export default connect(mapStateToProps, null, null, { pure: false })(SidebarRight);

const Inner = styled.div({
  paddingTop: 80
});
